import React from 'react';
import SelectDropdown from './SelectDropdown';

export default class LocationSelect extends React.Component {
  constructor(props) {
    super(props);
    this.handleLocationChange = this.handleLocationChange.bind(this);
  }

  handleLocationChange(locationId) {
    this.props.updateCurrentLocation(locationId);
  }

  render() {
    const { locations, currentLocation } = this.props;
    return (
      <SelectDropdown
        onChange={this.handleLocationChange}
        value={currentLocation.id}
        options={locations}
        aria-label="Sub-Account Select Box"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LocationSelect.js